import Vue from 'vue';
import moment from 'moment';

const state = {
    paymentSchema: [],
}

const mutations = {
    SET_PAYMENT_SCHEMA(state, response) {
        state.paymentSchema = response;
    },
    SET_UNIT_LEASE_TAG(state, payload) {
        if (payload && payload.length > 0) {
            state.units = state.units.map(unit => {
                unit.children = unit.children.map(child => {
                    if (!child.targetUnit || !child.targetUnit.orderCode) return child;
                    const updatedChild = payload.find(item => item.orderCode === child.targetUnit.orderCode);
                    return updatedChild ? { ...child, leaseTag: updatedChild.leaseTag } : child;
                });
                return unit;
            })
        }
    }
}

const actions = {
    async fetchPaymentPreviewSchema({ commit, state }) {
        commit('SET_PAYMENT_SCHEMA', []);
        commit('SET_LOADING', true);
        const { clientRequestMidMonth, midMonthEffectiveDate, effectiveMonth, units } = state
        const sentData = {
            effectiveDate: '',
            listItem: []
        }
        if (clientRequestMidMonth) {
            sentData.effectiveDate = midMonthEffectiveDate;
        } else {
            const effectiveDate = new Date(effectiveMonth + '-01');
            //effective date is fisrt day of next month
            effectiveDate.setMonth(effectiveDate.getMonth() + 1);
            effectiveDate.setDate(1);
            sentData.effectiveDate = effectiveDate.toISOString().split('T')[0];
        }
        for (const unit of units) {
            if (unit.children && unit.children.length > 0) {
                for (const child of unit.children) {
                    if (!child.selected || !child.targetUnit || !child.targetUnit.orderCode) continue;
                    let currentUnitIndex = sentData.listItem.findIndex(item => item.orderCode === child.targetUnit.orderCode);

                    if (currentUnitIndex < 0) {
                        sentData.listItem.push({
                            orderId: child.targetUnit.orderId,
                            orderCode: child.targetUnit.orderCode,
                            batch: child.targetUnit.batch,
                            billingCalculation: unit.billingCalculation,
                            billingStart: unit.billingStart,
                            billingPer: unit.billingPer,
                            recurringBillingDay: unit.recurringBillingDay,
                            customRecurringBillingDay: unit.customRecurringBillingDay,
                            leaseTag: child.leaseTag,
                            items: []
                        });
                        currentUnitIndex = sentData.listItem.length - 1;
                    }
                    if (currentUnitIndex >= 0 && unit.batch > sentData.listItem[currentUnitIndex].batch) {
                        sentData.listItem[currentUnitIndex] = {
                            ...sentData.listItem[currentUnitIndex],
                            billingCalculation: unit.billingCalculation,
                            billingStart: unit.billingStart,
                            recurringBillingDay: unit.recurringBillingDay,
                            customRecurringBillingDay: unit.customRecurringBillingDay,
                            billingPer: unit.billingPer,
                            leaseTag: child.leaseTag,
                        }
                    }
                    const childData = {
                        orderDetailsId: child.orderDetailsId,
                        serialNumber: child.serialNumber,
                        orderCode: child.orderCode,
                        productId: child.productId,
                        orderStatus: child.orderStatus,
                        price: child.price,
                        startRent: child.startRent,
                        endRent: child.endRent,
                    }
                    sentData.listItem[currentUnitIndex].items.push(childData)
                }
            }
        }

        try {
            const response = await Vue.prototype.$http.post(process.env.PREVIEW_PAYMENT_SCHEMA_TRANSFER_UNIT, sentData, {
                headers: {
                    'Asani-Token': localStorage.getItem('jwt')
                }
            });

            if (response.data.status !== 200) {
                const errorMessage = response.data.message;
                return {
                    isSuccess: false,
                    message: errorMessage
                }
            }
            commit('SET_PAYMENT_SCHEMA', response.data.content);
            return {
                isSuccess: true,
                data: response.data.content
            };
        } catch (error) {
            const errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'An error occurred while fetching the payment preview schema.';
            return {
                isSuccess: false,
                message: errorMessage
            };
        } finally {
            commit('SET_LOADING', false);
        }
    }
}

const getters = {
    getPaymentSchema: (state) => state.paymentSchema.map(item => {
        return {
            ...item,
            checked: false,
        }
    })
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/components/RentAdjustment/FormTabs/PaymentPreview/store.js